import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import vuetify from './plugins/vuetify';

import appSettings from './mixins/config/appSettings'
import {SanctumAuthPlugin} from "@/auth/sanctum";
import {WorkSessionsPlugin} from "@/workSessions"
//Sanitize html!
import sanitizeHTML from 'sanitize-html';

Vue.prototype.$sanitize = sanitizeHTML;

Vue.use(SanctumAuthPlugin, router);
Vue.use(WorkSessionsPlugin);

Vue.config.productionTip = false

vuetify.theme =  {
      primary: "#FFCC33",//appSettings.data().appSettings.colors.primary,
      secondary: appSettings.data().appSettings.colors.secondary,
      accent: appSettings.data().appSettings.colors.accent
}

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')